/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { closelightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const ReportCardDetail = (props) => {
  const [zPos, setZPos] = useState(45)
  const [content, setContent] = useState({});
  const [dataInfo, setDataInfo] = useState({ provider: "", status: "", uuid: "", address: "", reference: "", first_funding: "" });

  const testInfo = [
    { label: "Mensajería", key: "provider", provider: "" },
    { label: "Estatus mensajería", key: "status", status: "" },
    { label: "UUiD de tarjeta", key: "uuid", uuid: "" },
    { label: "Dirección", key: "address", address: "" },
    { label: "Referencia dirección", key: "reference", reference: "" },
    { label: "Dirección de envío", key: "address", address: "" },
    { label: "Fecha first funding", key: "first_funding", first_funding: "" },
  ];

  const history = useHistory();

  useEffect(() => {
    setContent(props.contentModal);
    let item = props.contentModal.content;
    if (item.hasOwnProperty("tracking") && item.tracking.hasOwnProperty("tracking_number_shipping")) {
      let body = {
        email: item["customer"]["email"],
        tracking: item["tracking"]["tracking_number_shipping"],
      };
      requestGuide(item, body);
    } else {
      getDataLocal(item);
    }
  }, []);

  const requestGuide = async (item, body) => {
    props.changeLoader(true);
    setZPos(-1)
    let request = await API.service("guideConsult", body, props.pos, props.changeAlert, props.changeLoader, history);

    if (request["status"] == 200 && request["data"].data.response == "OK") {
      let info = request["data"].data.widget[0].content;
      info["uuid"] = item["uuid"];

      setDataInfo(JSON.parse(JSON.stringify(info)));
      props.changeLoader(false);
      setZPos(45)
    } else {
      getDataLocal(item);
    }
  };

  const getDataLocal = (item) => {
    let di = dataInfo;
    let address = "";
    di.first_funding = "";
    di.provider = "";
    di.status = "";
    di.uuid = item["uuid"];

    if (item["tracking"] && item["tracking"]["shipment"] && item["tracking"]["shipment"]["address"]) {
      address = item["tracking"]["shipment"]["address"]["street"] + " No ext " + item["tracking"]["shipment"]["address"]["extnum"];
      if (item["tracking"]["shipment"]["address"]["intnum"]) {
        address = address + " int. " + item["tracking"]["shipment"]["address"]["intnum"];
      }
      address = address + " " + item["tracking"]["shipment"]["address"]["locality"] + ", " + item["tracking"]["shipment"]["address"]["zip"];
      di.address = address;
    } else if (item["tracking"] && item["tracking"]["provider"]) {
      di.provider = item["tracking"]["provider"]  
    }

    setDataInfo(JSON.parse(JSON.stringify(di)));
    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle style={{marginBottom: "0"}} >
          {content["title"]}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }} >
            <Grid item xs={12} >
              <hr style={{margin: "6px 0 14px 0"}}/>     
            </Grid>

            {testInfo?.map((item, index) => {
              return (
                <Grid container spacing={2} key={`info-${index}`} sx={{ marginLeft: "0px", marginTop: "-10px" }}>
                  <Grid item xs={4} sx={{color: "#969BA0"}}>
                    {item.label}
                  </Grid>
                  <Grid item xs={8}>			
                    {dataInfo[item.key] || "---"}
                  </Grid>
                </Grid>
            )})}          
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={closelightbox} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default ReportCardDetail;
